import { ePageBaseStatus } from "../../../models/ePageBaseStatus"
import { IDotDanhGiaActions } from "../../action-types/danh-gia/IDotDanhGiaActionType"
import { IDotDanhGiaReducer } from "../../page-state-model/danh-gia/IDotDanhGiaReducer"

const iniState: IDotDanhGiaReducer = {
    status: ePageBaseStatus.is_not_initialization,
    dotDanhGias: [],
    filter: {
        dm_truong_id: 0,
        nam_hoc: ""
    },
}
export const dotDanhGiaReducer = (state: IDotDanhGiaReducer = iniState, action: IDotDanhGiaActions): IDotDanhGiaReducer => {
    switch (action.type) {
        case "DOT_DANH_GIA_CHANGE_FILTER":
            return {
                ...state,
                filter: action.payload,
                status: ePageBaseStatus.is_need_reload
            }
        case "DOT_DANH_GIA_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "DOT_DANH_GIA_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                dotDanhGias: action.payload
            }
        case "DOT_DANH_GIA_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed
            }
        case "DOT_DANH_GIA_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                dotDanhGiaEditing: action.payload
            }
        case "DOT_DANH_GIA_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "DOT_DANH_GIA_SAVE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "DOT_DANH_GIA_SAVE_SUCCESS":
            return {
                ...state,
                isShowEditModal: false,
                status: ePageBaseStatus.is_need_reload
            }
        case "DOT_DANH_GIA_SAVE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed
            }
        case "DOT_DANH_GIA_DELETE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_deleting
            }
        case "DOT_DANH_GIA_DELETE_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload
            }
        case "DOT_DANH_GIA_DELETE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed
            }
        default:
            return state;
    }
}